// Colours
import {
  terracotta,
  bannerBackground,
  emeraldGreen,
} from "Constants/ColourConstants";

const baseCardContainer = {
  borderRadius: 4,
  background: "white",
  py: 2,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
};

export const styles = {
  pageBox: {
    mx: "5%",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    pb: 10,
  },
  cardContainer: {
    ...baseCardContainer,
    pb: 3,
  },
  paperContainer: {
    ...baseCardContainer,
    p: 1,
  },
  terracottaSwitch: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: terracotta,
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: terracotta,
    },
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
      color: terracotta,
      opacity: 0.6,
    },
  },
  banner: {
    backgroundColor: bannerBackground,
    pr: 1,
    py: 0,
    textAlign: "left",
  },
  fieldArrayRow: {
    border: `1.5px solid ${emeraldGreen}`,
    borderRadius: 2,
    padding: 2,
    marginBottom: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
};
